var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-sync"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"h-100 d-flex pt-2 pb-2 p-md-4"},[_c('div',{staticClass:"box shadow-box"},[_c(_vm.currentComponent,{tag:"component"})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }